import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import BasicTableComponent, { NumberRangeColumnFilter } from "../../components/basic.table"
import { getEMail, usePermissions } from "../../user/User"
import { useNavigate } from "react-router-dom"
import { fetchAndSetData } from "../../api/Axios"

const AddressList = ({filter, returnOnMissingPerms}) => {
    const navigate = useNavigate()
    
    const columns =  [{
        Header: "Name",
        accessor: "name"
    }, {
        Header: "IP Adresse",
        accessor: "address"
    }, {
        Header: "Score",
        accessor: "score",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
    }]
    
    const { permissions } = usePermissions(getEMail())
    const [addresses, setAddresses] = useState([])
    useEffect(() => {
        if(permissions.addresses !== undefined && permissions.addresses) {
            fetchAndSetData("/api/addresses" + (filter === undefined ? "" : "/" + filter), "IP Adressen konnten nicht geladen werden.", setAddresses)
        }
    }, [permissions, filter])

    return (
        <div>
            <BasicTableComponent columns={columns} data={addresses} editUrlPart="address" />
        </div>
    )
}
   
export default AddressList